import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { ReactComponent as Chevron } from "assets/svg/chevronRight.svg";
import RoundedButton from "./atoms/RoundedButton";

const Wrapper = styled(RoundedButton)`
  ${({ theme }) => theme.resFontSize.medium};
  align-items: center;
  color: ${({ theme }) => theme.palette.primary};
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  width: 100%;

  > svg {
    height: 1.2rem;
    margin-left: 1em;
    flex-shrink: 0;
  }
`;

const StepButton = ({ className, label, onClick }) => {
  const classes = ["StepButton"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")} onClick={onClick}>
      <span className="label ellipsis">{label}</span>
      <Chevron />
    </Wrapper>
  );
};

StepButton.displayName = "StepButton";

StepButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

StepButton.defaultProps = {
  className: null,
};

export default StepButton;
